module.exports = __webpack_public_path__ + "img/ditan_yj_maqiang.e3996592.jpg";